<template>
  <div class="form_manage">
    <div class="main_title">
      <crumb-tit :roots="roots">
        <span slot="breadTit">{{ breadTit }}</span>
        <span slot="secondTit">{{ breadTit }}</span>
      </crumb-tit>
      <header-tip />
    </div>
    <intercept-main :level="level" />
  </div>
</template>

<script type="text/ecmascript-6">
import interceptMain from './InterceptMain'
import CrumbTit from '@/components/pc/config/CrumbTit'
import headerTip from '../components/Tip'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    interceptMain,
    CrumbTit,
    headerTip
  },
  data () {
    return {
      level: 3,
      roots: [{ 'to': 'smartForm', title: this.$t('message["1244"]') }, { 'to': 'smartForm', title: this.$t('message["1168"]'), 'query': { tab: 'subRecord' } }]
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    breadTit () {
      return this.$t('message["584"]')
    }
  },
  watch: {
    baseinfo (val) {
      // 判断权限
      const { level, system_role: systemRole, projectname, comname } = val
      this.$route.meta.title = `${this.$t('message["584"]')}-${projectname}-${comname}`
      let aLeavel = level.split(',').map(item => Number(item))
      if ([1, 2].includes(systemRole)) {
        // return '负责人/观察员'
        this.level = 3
      } else if (aLeavel && aLeavel.includes(1)) {
        // return '主管'
        this.level = 1
      } else if (aLeavel && aLeavel.includes(2)) {
        // return '组长'
        this.level = 2
      } else {
        // return '普通'
        this.level = 0
      }
    }
  },
  async created () {
    await this.getPersonList()
  },
  methods: {
    ...mapActions('smart/manage', ['getPersonList'])
  }
}
</script>

<style scoped lang="scss">
.main_title {
  position: relative;
}
.form_manage {
  color: #333;
}
.table_time {
  .time_division,
  .time_date {
    font-size: 12px;
    line-height: 16px;
  }
  .developer {
    margin-top: 4px;
  }
  .time_division {
    color: $gray;
  }
  .font_normal {
    font-size: 14px;
    color: #333;
  }
}
</style>
